import generateUuid from 'uuid/v4'

import { isTestMode } from '../VNAndroidSDK/Utils'

import { invoiceNumber } from './orderNumbers'

const fakeSuccessResponse = (uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial) => {
  const orderInvoiceNumber = hRef || invoiceNumber(orderNumber)

  return {
    amount: amount || '0.00',
    reasonText: 'OK',
    tipAmount: tipAmount || '0.00',
    merchantReferenceCode: orderInvoiceNumber,
    tokenInformation: {
      tokenExpiration: '1231',
      cardExpirationMonth: '12',
      cardExpirationYear: '31',
      token: '8045771714357049',
    },
    transId: orderInvoiceNumber,
    cardType: 'VISA',
    responseName: 'onSuccess',
    message: 'Approved',
    receiptData: {
      approvalCode: 'A',
      maskedPan: '123400000001234',
      authStatus: 'Approved',
      maskedCardNumber: '7049',
    },
    uuid: uuid || generateUuid(),
    cardIssuer: 'VISA DEBIT',
    authResponse: {
      authorizationCode: '478645',
      processorTransactionId: '1920108221202409170832093926',
      reconciliationId: '6FFDC0817446EE7C',
    },
    isOfflineApproval: false,
    transType: 'sale',
    requestId: orderInvoiceNumber,
    cardholderName: 'VALUED CUSTOMER',
    invoiceNumber: orderInvoiceNumber,
    reasonCode: '000000',
    status: 'ACCEPT',
  }
}

const fakeDeclineResponse = (uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial) => {
  const orderInvoiceNumber = hRef || invoiceNumber(orderNumber)

  return {
    amount: amount || '0.00',
    reasonText: 'DECLINE',
    tipAmount: tipAmount || '0.00',
    merchantReferenceCode: orderInvoiceNumber,
    tokenInformation: {
      tokenExpiration: '1231',
      cardExpirationMonth: '12',
      cardExpirationYear: '31',
      token: '4479289dn3r6bh24',
    },
    transId: orderInvoiceNumber,
    cardType: 'VISA',
    responseName: 'onSuccess',
    message: 'Host Declined',
    receiptData: {
      approvalCode: 'D',
      maskedPan: '',
      authStatus: 'Host Declined',
      maskedCardNumber: '4479',
    },
    uuid: uuid || generateUuid(),
    cardIssuer: 'VISA DEBIT',
    authResponse: {
      authorizationCode: '',
      processorTransactionId: '2620016291202409222352210941',
      reconciliationId: '2CB720C803024F56',
    },
    isOfflineApproval: false,
    transType: 'sale',
    requestId: orderInvoiceNumber,
    cardholderName: ' /',
    invoiceNumber: orderInvoiceNumber,
    reasonCode: '000100',
    status: 'DECLINED',
  }
}

class FakePeripheralBridge {
  static handlers = {
    executeSaleRequest: async ({ uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial }) => {
      // Wait a random amount of time between 1 and 3 seconds to simulate network latency.
      await new Promise((resolve) => setTimeout(resolve, Math.random() * 2000 + 1000))

      // Randomly choose between success and decline with a 10% chance of decline.
      const response =
        Math.random() > 0.1
          ? fakeSuccessResponse(uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial)
          : fakeDeclineResponse(uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial)
      this.handlers['handleResult'](response, () => {})
    },
    executeAuthRequest: async ({ uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial }) => {
      // Wait a random amount of time between 1 and 3 seconds to simulate network latency.
      await new Promise((resolve) => setTimeout(resolve, Math.random() * 2000 + 1000))

      // Randomly choose between success and decline with a 10% chance of decline.
      const response =
        Math.random() > 0.1
          ? fakeSuccessResponse(uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial)
          : fakeDeclineResponse(uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial)
      this.handlers['handleResult'](response, () => {})
    },
  }

  static runHandler = (handlerName, data, callback) => {
    if (!this.handlers || !this.handlers[handlerName]) return

    this.handlers[handlerName](data, callback)
  }
  static getBridge() {
    return {
      call: (method, data, callback = () => {}) => this.runHandler(method, data, callback),
      callHandler: (handlerName, data, callback = () => {}) => this.runHandler(handlerName, data, callback),
      registerHandler: (handlerName, handler) => {
        this.handlers[handlerName] = handler
      },
    }
  }
}

export default class PeripheralBridge {
  static setupWebViewJavascriptBridge = (callback) => {
    if (window.WebViewJavascriptBridge) return callback(window.WebViewJavascriptBridge)
    if (window.VNCallbacks) return window.VNCallbacks.push(callback)

    window.VNCallbacks = [callback]

    var VNIframe = document.createElement('iframe')
    VNIframe.style.display = 'none'
    VNIframe.src = 'vnscheme://__BRIDGE_LOADED__'

    document.documentElement.appendChild(VNIframe)

    setTimeout(function () {
      document.documentElement.removeChild(VNIframe)
    }, 0)
  }

  static getBridge() {
    if (isTestMode()) return FakePeripheralBridge.getBridge()

    return window?.WebViewJavascriptBridge
  }
}
